import { jsx as o, jsxs as i } from "react/jsx-runtime";
import { TooltipProvider as n } from "@radix-ui/react-tooltip";
import { ThemeProvider as m, useTheme as s } from "./index.es173.js";
import { ScreenZoomProvider as c, useScreenSize as p, useScreenZoom as d } from "./index.es530.js";
import { NotificationContainer as f } from "./index.es543.js";
import { ModalsContainer as h } from "./index.es92.js";
const P = ({ children: e }) => /* @__PURE__ */ o(m, { children: /* @__PURE__ */ o(c, { children: /* @__PURE__ */ i(n, { children: [
  e,
  /* @__PURE__ */ o(f, {}),
  /* @__PURE__ */ o(h, {})
] }) }) }), S = () => {
  const e = s() || {}, r = p(), t = d();
  return { theme: { ...e }, zoom: { size: r, ...t } };
};
export {
  P as UiComponentsProvider,
  S as useUiComponents
};
//# sourceMappingURL=index.es529.js.map
